module.exports = __webpack_public_path__ + "img/hot-tub-person.58d9dd77.svg";